export default function Contact() {
    return <h1>Contact</h1>
}